import { Box, Menu, MenuItem, styled } from '@material-ui/core';

export const SearchButton = styled(Box)({
  width: 100,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 8,
  padding: '8px 12px 8px 16px',
  borderRadius: 20,

  '&:hover': {
    backgroundColor: '#fff'
  },

  '& svg': {
    width: 16
  }
});

export const StyledMenu = styled(Menu)(({ theme }) => ({
  margin: theme.spacing('4px', 1),
  marginLeft: -20,

  '& .MuiPaper-root': {
    borderRadius: 20,
    minWidth: 178,
    boxShadow:
      '0px 24px 48px -8px rgba(48, 54, 60, 0.12), 0px 4px 4px 0px rgba(48, 54, 60, 0.04)',

    '& ul': {
      padding: 10
    }
  }
}));

export const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
  borderRadius: 24,
  height: 48,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: theme.spacing('12px', '12px')
}));

export const StartAndorment = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2)
}));
